import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { TextButton } from '@producer/ui-kit';
import styled from 'styled-components';

import { NavMenu, NavMenuItem } from '../../../components/nav-menu';
import { getCree8AccountUrl } from '../../../configuration/config';
import { useAuth } from '../../../cree8-auth';
import { uiStore } from '../../../core/stores/ui-store';

export const MobileUserSettingsNavigation = () => {
  const location = useLocation();
  const pathname = location.pathname.split('/');
  const auth = useAuth();

  useEffect(() => {
    uiStore.pageTitle = {
      label: 'Personal settings',
    };

    uiStore.showBack = true;
  }, []);

  const handleLogout = () => {
    void auth.signoutRedirect();
  };

  const mobileMenu = [
    {
      key: 'profile',
      label: 'Profile',
      href: `./profile`,
    },
    {
      key: 'security',
      label: 'Password and authentication',
      href: getCree8AccountUrl(),
      external: true,
    },
    {
      key: 'notifications',
      label: 'Notifications',
      href: `./notifications`,
    },
    {
      key: 'preferences',
      label: 'Preferences',
      href: `./preferences`,
    },
    {
      key: 'workspaces',
      label: 'Workspaces',
      href: `./workspaces`,
    },
  ];

  return (
    <Container>
      <NavMenu>
        {mobileMenu.map(({ key, label, href, external }) => (
          <NavMenuItem
            key={key}
            to={href}
            state={location.state}
            label={label}
            external={external}
            isActive={
              !external && ((pathname.length === 4 && key === 'profile') || pathname.includes(key))
            }
          />
        ))}
      </NavMenu>

      <TextButton text="Logout" type="button" onClick={handleLogout} />
    </Container>
  );
};

const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 1.6rem;
`;
